import * as actions from './actions';

const initialState = {
    error: null,
    recipes: null,
    proportions: null,
    initialCalc: false,
    loading: false,
};

export default function calcReducer(state = initialState, action) {
    switch (action.type) {
        // fetch

        case actions.FETCH_RECIPES_INSTRUCTIONS.REQUEST:
            return { ...state, error: null, loading: true };
        case actions.FETCH_RECIPES_INSTRUCTIONS.SUCCESS: {
            return { ...state, initialCalc: true, recipes: action.payload, loading: false };
        }
        case actions.FETCH_RECIPES_INSTRUCTIONS.FAILURE:
            return { ...state, initialCalc: false, error: action.payload, loading: false };


        case actions.FETCH_RECIPES_PROPORTIONS.REQUEST:
            return { ...state, error: null, loading: true };
        case actions.FETCH_RECIPES_PROPORTIONS.SUCCESS: {
            return { ...state, initialCalc: true, proportions: action.payload, loading: false };
        }
        case actions.FETCH_RECIPES_PROPORTIONS.FAILURE:
            return { ...state, initialCalc: false, error: action.payload, loading: false };

        default:
            return state;
    }
}